import React from "react";
import Resume from "./Felix.pdf";
import "./Button.css";

export default function Button() {
  return (
    <div className="buttons">
      <a href="https://vimeo.com/449823774" target="_blank" rel="noreferrer">
        <button>Unreal Engine</button>
      </a>

      <a href={Resume} target="_blank" rel="noreferrer">
        <button>Resume</button>
      </a>

      <a href="https://vimeo.com/772373155" target="_blank" rel="noreferrer">
        <button>Lighting</button>
      </a>
    </div>
  );
}
